function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBatterycapacity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 170",
    d: "M34 16.2h-2.19V14a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h24.85a1 1 0 0 0 1-.95V23.8H34a1 1 0 0 0 1-.95v-5.7a1 1 0 0 0-1-.95zm-3.51 9.51H6.28V14.29h24.25zm3.19-3.17h-1.87v-5.08h1.91zM13 23.94H8.89v-7.7H13zm5.95 0h-4.11v-7.7H19zm5.95 0h-4.11v-7.7h4.11z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBatterycapacity);
export default __webpack_public_path__ + "static/media/icn-batterycapacity.ff2d27b18ad2f37b1efe1a4c1656ad56.svg";
export { ForwardRef as ReactComponent };